import {
  Button,
  ButtonIcon,
  ButtonSpinner,
  ButtonText,
} from "@repo/components/src/ui/button";
import React, { ComponentProps } from "react";

type Props = {
  onPress?: () => void;
  loading: boolean;
  Icon: React.ElementType;
  label: string;
  className?: string;
  textClassName?: string;
  variant: ComponentProps<typeof Button>["variant"];
  size?: ComponentProps<typeof Button>["size"];
  rounded?: ComponentProps<typeof Button>["rounded"];
};

export default function LoginButton(props: Props) {
  const {
    onPress,
    loading,
    Icon,
    label,
    className,
    textClassName,
    variant,
    size = "lg",
    rounded = "3xl",
  } = props;
  return (
    <Button
      onPress={onPress}
      size={size}
      className={className}
      variant={variant}
      isDisabled={loading}
      rounded={rounded}
    >
      {loading ? (
        <ButtonSpinner />
      ) : (
        <ButtonIcon as={Icon} className={textClassName} />
      )}
      <ButtonText className={textClassName}>
        {loading ? "Cargando ..." : label}
      </ButtonText>
    </Button>
  );
}
